import { registerBlockType } from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import "../slider/swiper";
import ProfileSave from "./profileSave";
import ProfileEditor from "./profileEditor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: ProfileEditor,
  save: ProfileSave,
});
